<div class="col-12 white-background assign-sidebar p-3 pt-0" *ngIf="driverList">
  <div class="col-12 menu-header page-buttons grid head-marg">
    <div class="col-6 md:col-6 lg:col-6">
      <span class="bookingTime" translate>label_assign_driver</span>
      <span class="bookingTime" *ngIf="recordCount"> ({{recordCount}})</span>
    </div>

    <div class="col-3 md:col-3 lg:col-3 grid flex justify-content-end align-items-center"
      *ngIf="isAutoBroadcastAssign() && checkIfOutboundorSpecial">
      <div class="fontSize16 mr-2" translate> label_auto_broadcast</div>
      <div class="text-right pad-right-0px">
        <p-inputSwitch (onChange)="onSwitchChange($event); applyFilter('callOnlyApi')"
          [(ngModel)]="toAutoBroadcast"></p-inputSwitch>
      </div>
    </div>
  </div>

  <div class="col-12 grid flex align-items-center pb-0">
    <div class="col-12 md:col-2 lg:col-2 ">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>label_driver_type</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [options]="driverTypeOptions" [(ngModel)]="selectedDriverType"
          (onChange)="changeFilter('selectedDriverType',selectedDriverType); applyFilter('callOnlyApi')"
          [placeholder]="pickupDropPlaceHolder">
        </p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-2 lg:col-2 ">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>label_parking_locations</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [options]="parkingLocationsOptions" [(ngModel)]="selectedParkingLocation"
          (onChange)="changeFilter('selectedParkingLocation',selectedParkingLocation); checkParkingAndQueue('selectedParkingLocation'); applyFilter('callOnlyApi')"></p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-2 lg:col-2 ">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>label_queue_location</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [options]="queueLocationList" [(ngModel)]="selectedQueueLocation"
          (onChange)="changeFilter('selectedQueueLocation',selectedQueueLocation); checkParkingAndQueue('selectedQueueLocation'); applyFilter('callOnlyApi')">
        </p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-2 lg:col-2 ">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>label_sort_by_list</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [options]="sortByFilter" [(ngModel)]="requestedSortKey"
          (onChange)="changeFilter('requestedSortKey',requestedSortKey); applyFilter('callOnlyApi')">
        </p-dropdown>
      </div>
    </div>

    <div class="col-12 md:col-2 lg:col-2 ">
      <div class="form-label">
        <label for="companyId" class="list-filter-lbl" translate>label_vehicle_type</label>
      </div>
      <div class="form-control filter-drop-down">
        <p-dropdown [style]="{'width': '100%'}" [options]="vehicleTypeOptions" [(ngModel)]="selectedVehicleType"
          (onChange)="changeFilter('selectedVehicleType',selectedVehicleType); applyFilter('callOnlyApi')">
        </p-dropdown>
      </div>
    </div>

   <div class="col-12 md:col-2 lg:col-2 ">
    <div class="form-label">
      <label id="label_team" for="serviceType" translate>label_team</label>
    </div>
    <div>
      <p-dropdown id="groupOptions" [options]="groupOptions" [(ngModel)]="selectedGroup"
        (onChange)="changeFilter('selectedGroup',selectedGroup); applyFilter('callOnlyApi')">
      </p-dropdown>
      </div>
    </div>
  </div>

  <div class="col-12 grid flex align-items-center py-0">
    <div class="col-12 md:col-3 lg:col-3 ">
      <div class="form-label">
        <label id="label_team" for="serviceType" translate>label_dispatch_zone</label>
      </div>
      <div>
        <p-multiSelect id="groupOptions" [options]="serviceCitiesOptions" [(ngModel)]="selectedDispatchAddress"
          (onChange)="changeFilter('selectedDispatchAddress',selectedDispatchAddress); applyFilter('callOnlyApi')"
          [filter]="true" maxSelectedLabels="0" selectedItemsLabel="{0} items"
          [placeholder]="'label_all' | translate">
        </p-multiSelect>
      </div>
    </div>

    <div class="col-10 md:col-9 lg:col-9">

      <button [ngClass]="filterApplied? 'filter-btn-apply filter-applied' : 'filter-btn-apply'" pButton appRipple
        (click)="onclickFilterApply('apply')" type="button" icon="fa fa-check"
        [label]="'label_apply' | translate"></button>
      <button pButton appRipple class="reset-btn" (click)="resetFilter()" type="button" icon="fa fa-undo"
        [label]="'label_reset' | translate"></button>
    </div>
  </div>

  <div class="col-12 p-0" *ngIf="loadGrid()">
    <app-mi-grid-v2 [url]="url" [columnDefs]="columns" [paginationPageSize]="paginationCount" [uniqId]="uniqId"
      (rowClickedEvent)="onRowClicked($event)" (totalCount)="totalCount($event)" divClass="mi-grid"
      [overflowShow]="true"></app-mi-grid-v2>
  </div>

</div>

<p-dialog [header]="'label_confirmation' | translate" [(visible)]="confirmationPopup" [modal]="true"
  styleClass="confirmation_popup" position="center center" responsive="true"
  [contentStyle]="{'overflow':'visible', 'border-radius': 0}" class="cancel-popup-footer">
  <div>
    <p class="label_luggage_booking_cancellation">{{confirmationMessage}}</p>
  </div>

  <ng-template pTemplate="footer">
    <div>
      <button class="negative-button" pButton appRipple type="button" [label]="'label_cancel' | translate"
        (click)="closeCancellationReason()"></button>
      <button class="confirmBtn" pButton appRipple type="button" [label]="'label_confirm' | translate"
        (click)="confirmCancellationReason()"></button>
    </div>
  </ng-template>
</p-dialog>